import type { Key, ValueOptions } from '../@types';

const key: Key = 'paywall-email-modal';

const getItem = () => {
	return localStorage.getItem(key) as ValueOptions;
};

const setItem = (value: NonNullable<ValueOptions>) => {
	localStorage.setItem(key, value);
	window.dispatchEvent(new Event('storage'));
};

const removeItem = () => {
	localStorage.removeItem(key);
	window.dispatchEvent(new Event('storage'));
};

export const paywallLocalStorage = {
	getItem,
	setItem,
	removeItem
};
